module.exports = __webpack_public_path__ + "img/vip_bg_1.bb37111d.png";